import type { ReactNode } from 'react'
import type { FieldStatus } from './field-feedback'
import { feedback } from './FieldFeedback.css'

export function FieldFeedback({
  id,
  status = 'neutral',
  children,
}: {
  id?: string
  status?: FieldStatus
  children?: ReactNode
}) {
  if (!children) return null

  return (
    <span id={id} className={feedback({ status })} role={status === 'error' ? 'alert' : undefined}>
      {children}
    </span>
  )
}
